<template>
	<div class="live-chat-wrapper">
		<v-btn class="mb-3 live-chat-open-button" v-if="!open" :color="buttonColor" @click="openChat" fab>
			<v-icon :color="iconColor">mdi-chat</v-icon>
			<v-badge v-if="unread_messages" content="1" color="red"></v-badge>
		</v-btn>
		<v-card class="screenshare" :class="{'d-none': !media_stream }">
				<v-toolbar dense flat>
					Sharing screen with chat
					<v-spacer></v-spacer>
					<v-btn icon @click="endShareScreen"><v-icon>mdi-close</v-icon></v-btn>
				</v-toolbar>		
			<v-card-text>
				<video id="video" height="200px" width="300px" style="" autoplay></video>
			</v-card-text>
		</v-card>
		<v-card class="live-chat-window" :class="{open: open}">
			<v-toolbar dense flat>
					Chat
					<v-spacer></v-spacer>
					<v-btn icon @click="shareScreen"><v-icon>mdi-monitor-share</v-icon></v-btn>
					<v-btn icon @click="closeChat"><v-icon>mdi-close</v-icon></v-btn>
			</v-toolbar>	
			<v-card outlined class="ma-2 pa-2 live-chat-history">
				<v-row v-for="(msg, i) in message_history" :key="i">
					<v-col class="pb-0" cols="3">
						<b :color="msg.from == 'support' ? 'primary' : 'grey'">{{msg.from_name}}</b><br/>
						<span>{{ msg.time | moment("HH:MM:ss") }}</span>
					</v-col>
					<v-col class="pb-0" cols="9">
						{{msg.message}}
					</v-col>
				</v-row>
			</v-card>	
			<v-row class="live-chat-input">
				<v-col cols="10" class="pl-3">
					<v-text-field class="ml-2" dense rounded filled placeholder="Nachricht schreiben..." v-model="user_message" v-on:keyup.enter="sendMessage()"></v-text-field>	
				</v-col>
				<v-col cols="2" class="pa-0 pt-3">
					<v-btn class="mr-3" icon color="green" @click="sendMessage"><v-icon>mdi-arrow-right-bold</v-icon></v-btn>
				</v-col>
		</v-row>
		</v-card>
	</div>
</template>
<style lang="less">
	#video{
		margin: 0px;
		position: relative;
		top: -40px;
		left: -16px
	}
	.screenshare{
		position: fixed !important;
		height: 200px;
		width: 350px;
		right: 390px;
		bottom: 0px;
	}
	.live-chat-wrapper{
		position: fixed;
		right: 10px;
		z-index: 1000;
		width: 350px;
		max-width: 500px;
		bottom: 0px;
		padding-bottom: 0px;
		height: auto;
		text-align: right;
		.live-chat-open-button{
			// min-width: 150px;
			// float: right;
		}
		.live-chat-window{
			height: 0px;
			background-color: white;
			text-align: left;
			&.open{
				transition: height 0.3s;
				height: 400px;
			}
			.live-chat-history{
				height: 67%;
				font-size: 0.7em;
				overflow-x: hidden;
				overflow-y: scroll;

			}
			.live-chat-input{
				text-align: left;
				height: 30%;
			}
		}
	}
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	export default {
		name: "LiveChat", 
		props: ["show"],
		data: () => {
			return {
				open: false, 
				user_message: '', 
				media_stream: false,
				message_history: [], 
				unread_messages: false,
				autoresponse:	{ 
						from: "support", 
						from_name: "Support",
						message: "Thank you for your message. This is a demo. The chat feature is not currently live."
				}
			}
		}, 
		computed: {
			...Vuex.mapState({
				user: state => state.user
			}),
			buttonColor(){
				if( this.unread_messages ){
					return "green";
				}
				return "white"
			},
			iconColor(){
				if( this.unread_messages ){
					return "white";
				}
				return "accent"
			}
		},
		methods: {
			async startCapture(displayMediaOptions) {
				let captureStream = null;

				try {
				captureStream = await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);
				} catch(err) {
				console.error("Error: " + err);
				}
				return captureStream;
			},
			
			openChat(){
				this.$emit( "open" );
			}, 
			closeChat(){
				this.$emit( "close" )
			},
			sendMessage(){
				var msg = {
						message: this.user_message, 
						from_name: this.user.display_name, 
						time: new Date(), 
						from: this.user.id
					}
				this.message_history.push( msg );
				this.$store.dispatch( "user/saveChat", msg )
				this.user_message = ''
			},
			autoRespond(){				
				this.autoresponse.time = new Date();
				this.message_history.push(this.autoresponse)
			}, 
			shareScreen(){
				const self = this;
				self.startCapture().then( ( a ) => {
					self.media_stream = a;
					document.getElementById("video").srcObject = a;
				})
			}, 
			endShareScreen(){
				var videoElem = document.getElementById("video")
				let tracks = videoElem.srcObject.getTracks();
					tracks.forEach(track => track.stop());
					videoElem.srcObject = null;
				this.media_stream = false;
			}

		}, 
		watch: {
			message_history(){
				if( this.message_history.length == 1 ){
					setTimeout( this.autoRespond, 700)
				}
				if( this.open == false ){
					this.unread_messages = true;
				}
			}, 
			open(){
				if( this.open && this.unread_messages ){
					this.unread_messages = false
				}
			},
			show: {
				immediate: true,
				handler(){
					this.open = this.show;
				}
			}
		},
		mounted(){
		}
	}
</script>